import type { LoadedAuthoredGeneratedSchema } from '@cli-types/core-engine/add-field.js'
import { isRecord } from '@cli-utils/shared.js'

export function getSchemaDisplayName(loaded: LoadedAuthoredGeneratedSchema): string {
  const label = isRecord(loaded.schema) ? loaded.schema.label : undefined
  return typeof label === 'string' && label.trim() ? label : loaded.name
}
